import React, { Component } from 'react';
import { Popover, Button, Icon } from 'antd';
import FormList from '../../../basicElement/FormList.new.js';
import compareFn from '../Components/compareFn';
import { getMatchOption } from '../../../shared/selectFn';

class Form extends Component {
    getColumns = () => {
        const { mode, data, names, prevData, options } = this.props;
        const { investigationAreaId, investigationMedicineType, investigationByStageId } = data;
        const { areaOptions, diseaseOptions, medicineTypeOptions, byStageOption, periodOptions } = options;
        const showPeriod = getMatchOption(byStageOption, 'value', investigationByStageId).investigationByStageName === 'I期';

        // 字段属性配置
        const columns = [{
            key: 'studyId',
            type: 'text',
            attr: {
                name: names.studyId,
            },
        }, {
            key: 'productName',
            type: 'input',
            attr: {
                name: names.productName,
            },
            attrRules: {
                required: true,
                labelClassName: 'initialLineHeight',
            },
        }, {
            key: 'investigationAreaId',
            type: 'select',
            attr: {
                name: names.investigationAreaName,
                options: areaOptions,
            },
            attrRules: {
                required: true,
            },
        }, {
            key: 'diseaseId',
            type: 'select',
            attr: {
                name: names.diseaseName,
                options: diseaseOptions,
                disabled: !investigationAreaId,
            },
            attrRules: {
                required: true,
            },
        }, {
            key: 'investigationMedicineType',
            type: 'select',
            attr: {
                name: names.investigationMedicineType,
                options: medicineTypeOptions,
            },
            attrRules: {
                required: true,
            },
        }, {
            key: 'investigationByStageId',
            type: 'select',
            attr: {
                name: names.investigationByStageName,
                options: byStageOption,
                disabled: !investigationMedicineType,
            },
            attrRules: {
                required: true,
            },
        }, {
            key: 'periodId',
            type: 'select',
            attr: {
                name: names.period,
                options: periodOptions,
            },
            attrRules: {
                required: true,
            },
            display: showPeriod,
        }];

        // 字段值、显示状态配置
        const traverseColumns = function (columns) {
            columns.forEach(column => {
                const { key, type, attr } = column;
                if (mode === 'compare') {
                    attr.value = compareFn(prevData, data, key);
                } else {
                    attr.value = data[key];
                    if (mode === 'note') {
                        const attrRules = column.attrRules || (column.attrRules = {});
                        attrRules.suffix = (
                            <Popover
                                title={
                                    <div>
                                        <div style={{ display: 'flex' }}>
                                            <strong>陶志红[200166] 2021-03-02 12:52</strong>
                                            <div style={{ marginLeft: 16 }}>
                                                <Icon type="check-square-o" />
                                                <Icon type="edit" />
                                                <Icon type="close-circle-o" />
                                            </div>
                                        </div>
                                        <p style={{ lineHeight: '24px' }}>
                                            计划书填写日期2021年3月2日
                                        </p>
                                    </div>
                                }
                                overlayClassName="quotation-popover"
                                content={<Button type="primary">添加备注</Button>}
                            >
                                <Icon type="message" className="icon-note" style={{ marginLeft: 16 }} />
                            </Popover>
                        );
                    }
                }
                column.comment = {
                    name: names.comments
                };
            });
        }
        traverseColumns(columns);

        return columns;
    }

    render() {
        const { formRef, language, editable, onChange } = this.props;
        return (
            <FormList
                fieldWidth={320}
                language={language}
                editable={editable}
                columns={this.getColumns()}
                onChange={onChange}
                className="hasComment"
                ref={el => formRef(el)}
            />
        );
    }
}

export default Form;


// WEBPACK FOOTER //
// ./src/components/quotation/Production/Params/Form.js